import type { BrandConfig } from '../types'
import placeholderImage from './assets/placeholder.svg'
import logoImage from './assets/logo.svg'
import testimonial1 from './assets/testimonial-1.svg'
import testimonial2 from './assets/testimonial-2.svg'
import testimonial3 from './assets/testimonial-3.svg'

const config: BrandConfig = {
  appName: 'DesignCore',
  brandName: 'DesignCore',
  description: 'Sistema de agendamento para designers de interiores',
  logo: {
    src: logoImage,
    alt: 'Logótipo da marca',
  },
  heroImage: {
    src: placeholderImage,
    alt: 'Projeto de design de interiores',
  },
  serviceImage: {
    src: placeholderImage,
    alt: 'Consultoria de arquitetura',
  },
  testimonials: [
    {
      name: 'Marta Vieira',
      role: 'Designer de Interiores',
      text: 'O DesignCore ajuda-me a organizar as reuniões com os meus clientes de forma muito eficiente.',
      image: testimonial1,
    },
    {
      name: 'Família Andrade',
      role: 'Clientes',
      text: 'Agendar a consultoria para o nosso projeto foi simples e rápido. A designer foi super pontual!',
      image: testimonial2,
    },
    {
      name: 'Home & Decor',
      role: 'Estúdio de Design',
      text: 'Uma ferramenta fantástica para gerir múltiplos projetos e clientes ao mesmo tempo.',
      image: testimonial3,
    },
  ],
}

export default config
